import {backgroundProcessService} from 'common/src/modules/backgroundProcess/backgroundProcess.service';
import {RunningBGProcess} from '../../backgroundProcess/backgroundProcess.types';
import {jobsApi} from '../jobs.api';
import {JobResult, JobUIStatus} from '../jobs.types';
import getJobLink from './getJobLink';
import {INTERVAL_MS_DEFAULT} from '../jobs.consts';

async function waitForJob<Result extends JobResult>({
  jobId: jobExecutionId,
  internalIdentifier,
  jobName = '',
  subtitle,
  intervalMS = INTERVAL_MS_DEFAULT,
  bgProcess,
}: {
  jobId: number;
  internalIdentifier?: string;
  jobName?: string;
  subtitle?: string;
  intervalMS?: number;
  bgProcess?: RunningBGProcess;
}): Promise<{
  result: Result;
  bgProcess: RunningBGProcess;
}> {
  if (!bgProcess) {
    if (!!internalIdentifier && !!backgroundProcessService.getJobById(internalIdentifier))
      throw `Job with id ${internalIdentifier} already exists`;
    bgProcess = backgroundProcessService.startProcess(
      jobName,
      internalIdentifier || jobExecutionId.toString(),
    );
  }

  if (subtitle) bgProcess.setSubtitle(subtitle);
  bgProcess.setJobId(jobExecutionId);

  return new Promise((resolve, reject) => {
    const interval = setInterval(
      () =>
        jobsApi
          .getJobExecution<Result>(jobExecutionId)
          .then((res) => {
            if (res.status === JobUIStatus.Completed) {
              resolve({result: res.result, bgProcess});

              if (res.warnings.length) bgProcess.warn(res.warnings);
              else bgProcess.success();
              const link = getJobLink(res.result);
              if (link) bgProcess.setLink(link);

              clearInterval(interval);
            } else if ([JobUIStatus.Failed, JobUIStatus.Aborted].includes(res.status)) {
              throw res;
            }
          })
          .catch((e) => {
            reject(e);
            clearInterval(interval);
            bgProcess.fail(e);
          }),
      intervalMS,
    );
  });
}

export default waitForJob;
